import { rem } from 'polished';
import styled from 'styled-components';
import { BodyText } from '@unmind/design-system';

export const CardContainer = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.card};
  border-radius: ${rem(20)};
  overflow: hidden;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
  border: none;
  outline: none;
  padding: ${rem(20)} ${rem(8)} ${rem(8)} ${rem(8)};

  &:hover {
    transform: translateY(-2px);
  }
`;

export const CardTitle = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.semiBold,
  color: theme.colors.text.primary,
}))`
  text-align: center;
  padding-bottom: ${rem(16)};
  margin: 0;
  line-height: 1.3;
`;

export const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: ${rem(8)};
`;
